const STORAGE_KEY = 'eugenial_app_version';

/** Tras cada deploy, fuerza una recarga si el build en servidor es más nuevo. */
export async function ensureLatestVersion(): Promise<void> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return;

    const { version } = (await res.json()) as { version: string };
    const stored = localStorage.getItem(STORAGE_KEY);

    if (stored && stored !== version) {
      localStorage.setItem(STORAGE_KEY, version);
      window.location.replace(window.location.href);
      return;
    }

    if (!stored) {
      localStorage.setItem(STORAGE_KEY, version);
    }
  } catch {
    /* sin red o primera visita */
  }
}
